const cartQuantity = (products) => {
    document.querySelectorAll('.js-thumb.is-in-cart').forEach(thumb => {
        thumb.classList.remove('is-in-cart')
    })

    document.querySelectorAll('.js-in-cart-ribbon').forEach(thumb => {
        thumb.classList.add('hidden')
    })

    if (!products) {
        return
    }

    const productsInCartPrices = {};

    for (const product of Object.values(products)) {
        let price = 0

        // TODO: tu mozno uz z BE natahovat final_price, lebo mozno nemusia vzdy sediet centy?
        // ale uvidime, ked nastane budeme riesit
        if (product.is_action && product.custom_action_stock) {
            price += product.quantity * product['price' + (window.Eshop.options.pricesWithVat ? '_vat' : '')]

            if (product.custom_quantity_together > product.quantity) {
                price += (product.custom_quantity_together - product.quantity) * product['custom_basic_price' + (window.Eshop.options.pricesWithVat ? '_vat' : '')]
            }
        } else {
            price += product.quantity * product['price' + (window.Eshop.options.pricesWithVat ? '_vat' : '')]
        }

        productsInCartPrices[product.id] = price
    }

    for (const productCartId in productsInCartPrices) {
        const productPrice = productsInCartPrices[productCartId]

        document.querySelectorAll(`.js-thumb[data-product-cart-id="${productCartId}"]`).forEach(thumb => {
            thumb.classList.add('is-in-cart')
        })

        document.querySelectorAll(`.js-in-cart-ribbon[data-product-cart-id="${productCartId}"]`).forEach(ribbon => {
            ribbon.classList.remove('hidden')
            ribbon.querySelector('.sc-price').innerHTML = Format.price(productPrice)
        })
    }
}

rEvent.on('Cart.product.after_add', function (response) {
    if (!response || !response.status) {
        return
    }

    cartQuantity(response.products)
})

rEvent.on('Cart.product.removed', function (data) {
    if (!data || !data.status || !data.products) {
        return
    }

    cartQuantity(data.products)
})

rEvent.on('Cart.fetchedProducts', function (data) {
    if (!data) {
        return
    }

    const response = data.response

    if (!response || !response.status || !response.data) {
        return
    }

    cartQuantity(response.data.items)
})